module.exports = __webpack_public_path__ + "img/icon8.2ff4fe6b.svg";